<template>
  <v-container fluid>
    <v-form ref="form" v-model="form" @submit.prevent="submit">
      <v-row>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-if="!operation.is_draft">
          <v-switch
            dense
            hide-details
            v-model="departureCrewSignOnService.metadata.arrange_by_owner"
            label="Arrange By Principal?"
            class="mt-0 pt-0"
          ></v-switch>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!departureCrewSignOnService.metadata.arrange_by_owner">
          <v-text-field
            label="Total Crew Departure"
            placeholder="Enter Total Crew Departure"
            :rules="[rules.negative]"
            outlined
            dense
            type="number"
            v-model="departureCrewSignOnService.metadata.total_crew_signed_off"
            prepend-inner-icon="mdi-account"
            @input="calculateDepartureSignonPrice"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!departureCrewSignOnService.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Price Per Crew"
            placeholder="Enter Price Per Crew"
            :rules="[rules.negative]"
            outlined
            dense
            type="number"
            v-model="departureCrewSignOnService.metadata.price_per_member"
            prepend-inner-icon="mdi-currency-usd"
            @input="calculateDepartureSignonPrice"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!departureCrewSignOnService.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-text-field
            label="Departure Crew Sign On Service Charges"
            placeholder="Departure Crew Sign On Service Charges"
            outlined
            dense
            type="number"
            v-model="departureCrewSignOnService.amount"
            prepend-inner-icon="mdi-currency-usd"
            :hint="departureCrewHintText"
            :rules="amountRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!departureCrewSignOnService.metadata.arrange_by_owner">
          <v-select
            label="Crew Sign On Supplier"
            placeholder="Select Supplier"
            outlined
            dense
            v-model="departureCrewSignOnService.card_id"
            prepend-inner-icon="mdi-account"
            :items="crewSignOnSupplier"
            :rules="supplierRules"
            :disabled="isDisabled"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="4" class="pb-0" v-show="!departureCrewSignOnService.metadata.arrange_by_owner" v-if="$root.hasAccess('can_manage_operation_amount_details')">
          <v-select
            label="Tax"
            placeholder="Select Tax"
            outlined
            dense
            v-model="departureCrewSignOnService.metadata.tax"
            prepend-inner-icon="mdi-cash-fast"
            :items="taxes"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-textarea
            label="Remarks"
            placeholder="Enter Remarks"
            outlined
            dense
            hide-details
            :rows="2"
            v-model="departureCrewSignOnService.remarks"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0" v-if="$root.onlyAccountsCanAccess">
          <v-textarea
            label="Accounts Remarks"
            placeholder="Enter Accounts Remarks"
            outlined
            background-color="light-blue lighten-5"
            dense
            hide-details
            :rows="2"
            v-model="departureCrewSignOnService.accounts_remarks"
            class="accounts-remarks-field"
          ></v-textarea>
        </v-col>
        <v-col cols="12" class="pb-0">
          <v-btn class="float-right" color="success" outlined :disabled="loading" :loading="loading"
            @click="saveDetails">Save</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import rules from '../../../../utilities/validator';
  import _find from 'lodash/find';

  export default {
    name: 's-services-opted-crew-change-service',
    props: {
      operation: {
        type: Object,
        default: {},
      },
      isDraft: {
        type: Boolean,
        default: false,
      },
      servicesOpted: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        loading: false,
        form: false,
        isDisabled: false,
        rules,
        departureCrewSignOnService: {
          service_catalog_id: null,
          card_id: null,
          amount: 0,
          bill_type: 'Crew Sign Off Service',
          remarks: '',
          accounts_remarks: '',
          metadata: {
            total_crew_signed_off: 0,
            price_per_member: 50,
            tax: '',
            arrange_by_owner: false
          }
        },
        crewSignOnSupplier: [],
        sinodaCrewSupplier: [],
        departure_crew_calculated_amount: 0,
        taxes: ['0%', '9%']
      };
    },
    methods: {
      submit() {
        return this.$refs.form.validate();
      },
      handleOperationInit() {
        this.populateSuppliers();
      },
      initServiceOptedDetails() {
        const departureCrewSignOnService = _.find(this.servicesOpted, {bill_type: 'Crew Sign Off Service'});
        if (departureCrewSignOnService) {
          const savedMeta = departureCrewSignOnService.metadata || {};
          this.departureCrewSignOnService = {
            ...this.departureCrewSignOnService,
            ...departureCrewSignOnService,
            metadata: {
              ...this.departureCrewSignOnService.metadata,
              ...savedMeta,
            },
          };
          this.departureCrewSignOnService.amount = parseFloat(this.departureCrewSignOnService.amount || 0).toFixed(2);
          const pricePerMember = parseFloat(this.departureCrewSignOnService.metadata.price_per_member);
          this.departureCrewSignOnService.metadata.price_per_member = (
            Number.isFinite(pricePerMember) && pricePerMember > 0 ? pricePerMember : 50
          ).toFixed(2);
          this.departure_crew_calculated_amount = parseInt(this.departureCrewSignOnService.metadata.total_crew_signed_off || 0, 10)
            * parseFloat(this.departureCrewSignOnService.metadata.price_per_member || 0);
        }
      },
      calculateDepartureSignonPrice() {
        this.departure_crew_calculated_amount = parseInt(this.departureCrewSignOnService.metadata.total_crew_signed_off) * parseInt(this.departureCrewSignOnService.metadata.price_per_member);
        this.departureCrewSignOnService.amount = this.departure_crew_calculated_amount;
      },
      populateSuppliers() {
        this.$api.service_catalogs.get_suppliers_list('Crew Sign Off Service')
          .then((response) => {
            this.crewSignOnSupplier = response.suppliers;
            this.sinodaCrewSupplier = _find(this.crewSignOnSupplier, { name: 'Sinoda' });
            if (this.sinodaCrewSupplier) {
              this.departureCrewSignOnService.card_id = this.sinodaCrewSupplier.id;
              this.isDisabled = true;
            }
            this.departureCrewSignOnService.service_catalog_id = response.service_catalog_id;
            this.initServiceOptedDetails();
            // Reset card_id to Sinoda Supplier if it's undefined
            if (this.sinodaCrewSupplier && !this.departureCrewSignOnService.card_id) {
              this.departureCrewSignOnService.card_id = this.sinodaCrewSupplier.id;
            }
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          });
      },
      saveDetails() {
        if(!this.submit()) return;
        this.loading = true;
        this.departureCrewSignOnService = Object.assign(this.departureCrewSignOnService, {
          operation_id: this.operation.id
        });

        Promise.all([
            this.$api.operation_billed_items.save_service(this.departureCrewSignOnService)
          ]).then(() => {
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Crew Sign Off service updated successfully',
            });
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.loading = false));
      }
    },
    computed: {
      amountRules() {
        if (this.departureCrewSignOnService.metadata.arrange_by_owner) {
          return [this.rules.negative];
        } else {
          if (this.isDraft || (this.operation && this.operation.is_draft)) {
            return [this.rules.required, this.rules.negative];
          } else {
            return [this.rules.negative];
          }
        }
      },
      departureCrewHintText() {
        if (Number(this.departureCrewSignOnService.amount) !== this.departure_crew_calculated_amount) {
          return `Departure crew sign on service charges differs from calculated amount \S$${this.departure_crew_calculated_amount}`;
        } else {
          return "";
        }
      },
      supplierRules() {
        if (this.departureCrewSignOnService.metadata.arrange_by_owner) {
          return [];
        } else {
          return [this.rules.required];
        }
      }
    },
    watch: {
      operation(value) {
        this.handleOperationInit();
      },
    },
    created() {
      this.handleOperationInit();
    },
  };
</script>